import { formatDate } from "../lib/format";

export default function AuthorBlock({ author, title, date, updated }) {
  const initial = (author || "S").charAt(0);
  return (
    <div
      className="flex items-center gap-4 py-5 border-y border-neutral-200"
      data-testid="author-block"
    >
      <div className="w-11 h-11 rounded-full bg-indigo-100 text-indigo-800 flex items-center justify-center font-playfair text-lg">
        {initial}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-neutral-900">{author}</p>
        <p className="text-xs text-neutral-500">{title}</p>
      </div>
      <div className="text-right">
        <p className="text-xs text-neutral-500">Published {formatDate(date)}</p>
        {updated && updated !== date && (
          <p className="text-xs text-neutral-500">Updated {formatDate(updated)}</p>
        )}
      </div>
    </div>
  );
}
